module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_tape_mobile.478e6a01.jpg";